import script from "./CompletionRegistration.vue?vue&type=script&setup=true&lang=js"
export * from "./CompletionRegistration.vue?vue&type=script&setup=true&lang=js"

export default script